import React from "react";
import PropTypes from "prop-types";

import Icon from '@mui/material/Icon';

import {
    DirectionsBike,
    DirectionsCar,
    DirectionsWalk,
    Inbox,
    LocalShipping,
    MarkunreadMailbox
} from "@mui/icons-material";

import {makeStyles} from "@mui/styles";
import {infoColor} from "assets/jss/main";
import { ReactComponent as HeavyDeliveryImage } from "assets/img/heavy-delivery.svg";

const defaultShippingIconStyle = {
    color: infoColor,
    fontSize: "24px",
    border: `1px solid ${infoColor}`,
    borderRadius: "50%",
    padding: "7px",
    width: '40px',
    height: '40px',
    background: '#FFFFFF'
};

const useStyles = makeStyles(theme => ({
    largeShippingIcon: {
       ...defaultShippingIconStyle,
    },
    smallShippingIcon: {
        ...defaultShippingIconStyle,
        padding: "5px",
        width: '32px',
        height: '32px',
        fontSize: '20px'
    },
    xsSize: {
        ...defaultShippingIconStyle,
        padding: "5px",
        width: '24px',
        height: '24px',
    },
    noCircle: {
        padding: 'unset',
        border: 'unset',
        borderRadius: 'unset'
    }
}));

export default function ShippingIcon(
    {
        shippingMethod,
        size,
        noCircle,
        ...props
    })
{
    const classes = useStyles();

    let shippingIconClassName= classes.largeShippingIcon;

    if (size === 'small') {
        shippingIconClassName = classes.smallShippingIcon;
    }

    if (size === 'xs') {
        shippingIconClassName = classes.xsSize;
    }

    if (noCircle) {
        shippingIconClassName = `${shippingIconClassName} ${classes.noCircle}`;
    }

    function getDefaultShippingIcon(shippingMethod) {
        switch (shippingMethod.type) {
            case 'delivery':
            case 'postnl':
            case 'postNL':
            case 'bpost':
            case 'ups':
            case 'colissimo':
            case 'colissimoViaToopost':
                return <LocalShipping className={shippingIconClassName} />;
            case 'click-collect':
            case 'clickCollect':
            case 'clickAndCollect':
                return <DirectionsWalk className={shippingIconClassName} />;
            case 'drive':
                return <DirectionsCar className={shippingIconClassName} />;
            case 'bike':
                return <DirectionsBike className={shippingIconClassName} />;
            case 'relay-point':
            case 'mondialRelay':
            case 'mondialRelayViaToopost':
            case 'bring':
                return <MarkunreadMailbox className={shippingIconClassName} />;
            case 'locker':
                return <Inbox className={shippingIconClassName} />;
            case 'heavy-delivery':
            case 'heavyDelivery':
                return <HeavyDeliveryImage className={shippingIconClassName} />
            default:
                return <></>
        }
    }

    function getShippingIcon(shippingMethod) {
        if (
            shippingMethod
            && shippingMethod.icon
            && shippingMethod.icon !== ''
        ) {
            return (
                <Icon className={shippingIconClassName}>
                    {shippingMethod.icon}
                </Icon>
            )
        }

        return getDefaultShippingIcon(shippingMethod);
    }

    return getShippingIcon(shippingMethod);
}

ShippingIcon.defaultProps = {
    shippingMethod: {},
    size: 'large'
};

ShippingIcon.propTypes = {
    shippingMethod: PropTypes.shape({
        icon: PropTypes.string,
    }),
    size: PropTypes.oneOf(['small', 'large', 'xs'])
};
